export default __webpack_public_path__ + "static/media/logo.821a02a2.png";